function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import AuthenticationFooter from "@common/components/authentication/AuthenticationFooter";
import AuthenticationHeader from "@common/components/authentication/AuthenticationHeader";
import ForgottenPasswordRequest from "@common/components/authentication/ForgottenPasswordRequest";
import { SIGN_IN_DEFAULT_REDIRECT } from "@config/constants";
export var ForgottenPasswordRequestPage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ForgottenPasswordRequestPage, PureComponent);
    var _super = _create_super(ForgottenPasswordRequestPage);
    function ForgottenPasswordRequestPage() {
        _class_call_check(this, ForgottenPasswordRequestPage);
        return _super.apply(this, arguments);
    }
    _create_class(ForgottenPasswordRequestPage, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, authentication = _this_props.authentication, i18n = _this_props.i18n;
                var template = null;
                if (isEmpty(i18n)) {
                    template = /*#__PURE__*/ _jsx("div", {
                        children: "Loading...."
                    });
                } else {
                    if (authentication.token) {
                        var route = authentication.lastRequestedRoute || SIGN_IN_DEFAULT_REDIRECT;
                        template = /*#__PURE__*/ _jsx(Redirect, {
                            to: route
                        });
                    } else {
                        template = /*#__PURE__*/ _jsxs("div", {
                            className: "authentication-background forgotten-password-request-page-component",
                            children: [
                                /*#__PURE__*/ _jsx(AuthenticationHeader, {
                                    i18n: i18n
                                }),
                                /*#__PURE__*/ _jsx(ForgottenPasswordRequest, {
                                    i18n: i18n
                                }),
                                /*#__PURE__*/ _jsx(AuthenticationFooter, {
                                    hasBackLink: false,
                                    i18n: i18n
                                })
                            ]
                        });
                    }
                }
                return template;
            }
        }
    ]);
    return ForgottenPasswordRequestPage;
}(PureComponent);
var mapStateToProps = function(param) {
    var authentication = param.authentication;
    return {
        authentication: authentication
    };
};
export default connect(mapStateToProps, null)(ForgottenPasswordRequestPage);
